import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { UpdatePaymentScrapTradesService } from "@/features/accounts/payment/scraping/services/update-trades-service";
import { UpdatePaymentScrapTradesPostResponseModel } from "@/features/accounts/payment/scraping/services/update-trades-model";


export const useUpdatePaymentScrapTrades = () => {
  const { setError } = useContext(ErrorDialogContext);
  const loadingCtx = useContext(LoadingModalContext);
  const updatePaymentScrapTradesService = new UpdatePaymentScrapTradesService();
  
  // Look明細更新（サーバ版スクレイピング）
  const updatePaymentScrapTrades = async (
    accountGroupId: string,
    mlinkAccountId: string,
    mlinkId: string,
    startDate?: string,
    endDate?: string,
    sessionKey?: string,
    otpInfo?: string
  ): Promise<UpdatePaymentScrapTradesPostResponseModel | undefined> => {
    loadingCtx.setIsLoading(true);
    try {
      let urlEncodeOtpInfoContent = "";
      if (otpInfo !== undefined) {
        // otpInfoをjson形式に加工
        const jsonOtpInfo = `[${otpInfo}]`
        // otpInfoContentをbase64エンコード
        const utf8Bytes = new TextEncoder().encode(jsonOtpInfo);
        const base64OtpInfoContent = btoa(String.fromCharCode(...utf8Bytes));
        // otpInfoContentをurlエンコード
        urlEncodeOtpInfoContent = encodeURIComponent(base64OtpInfoContent);
      }
      const res = await updatePaymentScrapTradesService.updatePaymentScrapTrades({
        account_group_id: accountGroupId,
        payment_account_id: mlinkAccountId,
        payment_id: mlinkId,
        ...(startDate !== undefined && { start_date: startDate }),
        ...(endDate !== undefined && { end_date: endDate }),
        ...(sessionKey !== undefined && { session_key: sessionKey }),
        ...(otpInfo !== undefined && { otp_info: urlEncodeOtpInfoContent }),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("updatePaymentScrapTrades:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    updatePaymentScrapTrades: errorHandledAsync(updatePaymentScrapTrades, setError),
  };
};
